import { Box, Button } from "grommet";
import colors from "../colors";


const ScheduleAnAppointmentBar = () => {
  return (
    <Box background={{color:colors.dark,opacity:0.75}} pad="large" align="center">
      <Button color={colors.light2} primary label='Schedule an Appointment' size='large' href="/contact"/>
    </Box>
  );
};

export default ScheduleAnAppointmentBar;